import { Injectable } from '@angular/core';
import { FeatureFlagsRulesService, Http, QueryBus, Weaver, Wrapper } from '@skylab-angular-shared/core';
import { SalePatternRepositoryBase } from '@skylab-shared/business';
import { ClientRepository } from '../client/client.repo';
import { ProductRepository } from '../product/product.repo';
export { SalePatternRepositoryBase };

@Injectable({ providedIn: 'root'})
@Wrapper(SalePatternRepositoryBase)
export class SalePatternRepository {
    public constructor(
        http: Http,
        weaver: Weaver,
        productRepository: ProductRepository,
        clientRepository: ClientRepository,
        queryBus: QueryBus,
        featureFlagsRulesService: FeatureFlagsRulesService
    ) { }
}
